/** @typedef {'pending'|'running'|'succeeded'|'failed'|'timeout'|'cancelled'} CommandStatus */

export const CALENDAR_STORE_VERSION = 1;

export const EMPTY_SELECTION = Object.freeze({
   slotKeys: [],
   reservationId: "",
   anchorSlotKey: "",
});

export const EMPTY_VIEWPORT = Object.freeze({
   monthKey: "",
   scrollTop: 0,
   scrollLeft: 0,
   fastScroll: false,
   panning: false,
});
